// The draw.io read-only viewer URL — CCT-477.
//
// ⚠️ `#U` TAKES A URI-ENCODED URL AND NOTHING ELSE. Measured against the live viewer: a single
// stray space between `#U` and the address renders a blank page with no error at all, which is
// the worst possible failure for an authoring feature — the author sees nothing and has nothing
// to read. The older `?url=` parameter is deprecated.
//
// ⚠️ THE VIEWER FETCHES THE FILE ITSELF, AND CORS DID NOT BLOCK IT. Measured: the blob serves no
// `Access-Control-*` header at all, and the diagram still rendered, because draw.io falls back to
// its own relay. So no storage-account CORS rule is needed, and adding one would have been a
// change made on a guess.

/** Options the viewer understands, in the order the toolbar shows them. */
const PARAMS = [
  'lightbox=1',   // larger zoom, no page border
  // ⚠️ THE LAYER CONTROL IS CONDITIONAL, AND THIS OPTION ONLY ALLOWS IT. Measured on two real
  // files: a one-layer diagram shows zoom out / zoom in / fit / print / export and NO layers
  // button; a three-layer one shows the layers button too. So an author who attaches a flat
  // diagram and looks for layers is not facing a defect — there is nothing to toggle.
  'layers=1',
  'nav=1',        // page navigation when the file holds several
  'chrome=0',     // read-only: no edit chrome
].join('&');

const BASE = 'https://viewer.diagrams.net/';

/** An address we are willing to hand to the viewer, or `null`. */
export function estUrlDiagrammeValide(url: string | null | undefined): boolean {
  const u = (url || '').trim();
  if (!u) return false;
  // ⚠️ HTTPS ONLY. An `http://` diagram inside an HTTPS page is blocked as mixed content and,
  // again, shows nothing. Refusing it here lets the screen say why instead of going blank.
  return /^https:\/\/[^\s]+$/i.test(u);
}

/**
 * The viewer address for a diagram, or `null` when the source is unusable.
 *
 * ⚠️ RETURNS `null` RATHER THAN A BROKEN URL. A caller that gets null can say "no diagram";
 * a caller handed a malformed viewer link renders an empty white box forever.
 */
export function urlVisualiseur(diagramme: string | null | undefined): string | null {
  if (!estUrlDiagrammeValide(diagramme)) return null;
  return `${BASE}?${PARAMS}#U${encodeURIComponent((diagramme as string).trim())}`;
}
